// extracted by mini-css-extract-plugin
export default {"dayButtons":"NotificationsModal_dayButtons__OIdnn","dayButton":"NotificationsModal_dayButton__PNo9E","selected":"NotificationsModal_selected__O7Tv7"};